<template>
	<BaseButton class="btn-blue" @click="click" v-bind="$attrs" :is-loading="isLoading" :disabled="disabled !== undefined ? disabled : isClicked">
		<slot>{{ $t('general.save') }}</slot>
	</BaseButton>
</template>

<script>
import BaseButton from '@/components/forms/buttons/BaseButton';

export default {
	name: 'SaveButton',
	components: { BaseButton },
	props: {
		disabled: {},
		isLoading: {},
	},
	computed: {
		isClicked() {
			return this.$store.getters.getSaveButtonState;
		},
	},
	methods: {
		click($event) {
			this.$emit('click', $event);
			this.$store.commit('setSaveButtonState', 'clicked');
			// disable button after click on save to prevent double click on save button
			setTimeout(() => {
				this.$store.commit('setSaveButtonState', null);
			}, 2000); // TODO find a better way
		},
	},
};
</script>

<style scoped></style>
